<template>
  <aside class="side-rail">
    <div class="logo-cube" title="臻视 AI">
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" aria-hidden="true">
        <path d="M7 5 L17 5 L17 9 L12 17 L17 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <circle cx="17" cy="5" r="1.2" fill="currentColor" />
      </svg>
    </div>

    <nav class="rail-nav">
      <router-link
        v-for="item in navItems"
        :key="item.path"
        :class="['rail-item', { active: isActive(item.path) }]"
        :to="item.path"
      >
        <span v-html="item.icon" class="rail-icon"></span>
        <em>{{ item.label }}</em>
      </router-link>
    </nav>

    <div class="rail-foot">
      <button class="rail-mini" type="button" title="帮助">?</button>
      <details class="rail-user-menu">
        <summary class="rail-avatar" aria-label="用户菜单">
          {{ avatarLetter }}
        </summary>
        <div class="rail-user-pop">
          <div class="rail-user-name">{{ username }}</div>
          <form method="post" action="/logout" @submit.prevent="onLogout">
            <button type="submit" class="rail-logout-btn">退出登录</button>
          </form>
        </div>
      </details>
    </div>
  </aside>

  <main class="board-main">
    <router-view />
  </main>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useAuthStore } from '../stores/auth';

const route = useRoute();
const auth = useAuthStore();

const navItems = [
  {
    path: '/',
    label: '工作台',
    icon: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9.5L12 3l9 6.5V21a1 1 0 0 1-1 1h-5v-7H10v7H4a1 1 0 0 1-1-1z"/></svg>'
  },
  {
    path: '/video-examples',
    label: '模板库',
    icon: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polygon points="5 3 19 12 5 21 5 3"/></svg>'
  },
  {
    path: '/assets',
    label: '资产',
    icon: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 14l5-5 4 4 9-9"/></svg>'
  }
];

function isActive(path) {
  if (path === '/') return route.path === '/';
  return route.path === path || route.path.startsWith(path + '/');
}

const username = computed(() => (auth.user && auth.user.username) || '用户');
const avatarLetter = computed(() => username.value.charAt(0).toUpperCase());

async function onLogout() {
  await auth.logout();
  window.location.href = '/login';
}
</script>

<style>
/* 侧边栏样式由 /static/styles.css 已定义（.side-rail / .rail-item / .rail-foot 等），
   这里只补充本组件特有的细节，避免 !important。 */
.rail-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  color: currentColor;
}
.rail-icon svg { display: block; }

.board-main {
  margin-left: 76px; /* 与 .side-rail 同宽 */
  min-height: 100vh;
  position: relative;
}

@media (max-width: 768px) {
  .board-main { margin-left: 62px; }
}
</style>
